import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import { bezierScrollTo } from '@cred/shared/scroll'
import { event } from '@cred/shared/ga'
import { emitOnPageChange, withLinkClickEvent } from '@cred/react-analytics/hoc'

import styles from './styles.module.scss'

const DEFAULT_NEXT_LABEL = (
  <span>
    Next <i className="cred-icon icon-chevron-right" />
  </span>
)
const DEFAULT_PREVIOUS_LABEL = (
  <span>
    <i className="cred-icon icon-chevron-left" /> Previous
  </span>
)

const Pagination = (props) => {
  const {
    name,
    onChange = () => {},
    gaCategory,
    scrollToTop = true,
    pageCount,
    forcePage,
    className,
    nextLabel = DEFAULT_NEXT_LABEL,
    previousLabel = DEFAULT_PREVIOUS_LABEL,
  } = props

  const handlePageClick = (pagination) => {
    onChange(name, pagination.selected)

    if (scrollToTop) {
      bezierScrollTo(0, 0.4, 0.0, 0.2, 1, 1000)
    }

    if (gaCategory) {
      event({ category: gaCategory, action: 'Change page', label: pagination.selected + 1 })
    }
  }

  return (
    <div className={`${styles.pagination} ${className}`}>
      <ReactPaginate
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel="..."
        breakClassName="break-class"
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        forcePage={forcePage}
        onPageChange={handlePageClick}
        containerClassName="components-pagination-container"
        activeClassName="active"
      />
    </div>
  )
}

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  previousLabel: PropTypes.element,
  nextLabel: PropTypes.element,
  scrollToTop: PropTypes.bool,
  onChange: PropTypes.func,
  gaCategory: PropTypes.string,
  forcePage: PropTypes.number,
  className: PropTypes.string,
}

// Export named class and functions for unit tests
export { Pagination }

export default withLinkClickEvent(emitOnPageChange(Pagination))
